// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "iconfont";
  /* Project id 4017216 */
  src: url("//cdn.vstar.app/static/css/fonts/iconfont.woff2?t=169") format("woff2"), url("//cdn.vstar.app/static/css/fonts/iconfont.woff?t=1681525258204") format("woff"), url("//cdn.vstar.app/static/css/fonts/iconfont.ttf?t=1681525258204") format("truetype");
}
.vstar-star.tt-right {
  text-align: right;
}
.vstar-star.tt-center {
  text-align: center;
}
.vstar-star > * {
  display: inline-block;
  vertical-align: middle;
}
.vstar-star .star-item {
  height: auto;
  margin-right: 2px;
  font-size: 0;
  line-height: normal;
}
.vstar-star .star-item.nostar .trustoo-rating-icon path {
  fill: var(--nostar-color);
}
.vstar-star .star-item.half-star > .item-nostar .trustoo-rating-icon path {
  fill: var(--nostar-color);
}
.vstar-star .star-item .trustoo-rating-icon path {
  fill: var(--star-color);
}
.vstar-star .star-item.half-star {
  position: relative;
}
.vstar-star .item-star {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.vstar-star .item-nostar {
  font-size: 0;
}
.vstar-star i.trustoo-icon-star,
.vstar-star i.trustoo-icon-nostar {
  display: inline;
}
#vstar-reviews #reviews-body .trustoo-badge-icon {
  width: 14px;
  height: 14px;
}
#vstar-reviews .user-verified .trustoo-badge-icon {
  margin-right: 4px;
}
.product-icon-list.vstar-star .star-item,
.product-icon-list.vstar-star .trustoo-rating-icon {
  width: 20px;
  height: 20px;
}
.collection-icon-list .star-item,
.collection-icon-list .trustoo-rating-icon {
  width: 16px;
  height: 16px;
}
#vstar-reviews > #reviews-head .star-item,
#vstar-reviews > #reviews-head .trustoo-rating-icon {
  width: 20px;
  height: 20px;
}
.trustoo-widget #reviews-body .star-item,
.trustoo-widget #reviews-body .trustoo-rating-icon {
  width: 14px;
  height: 14px;
}
.noreviews-nostar .star-item,
.noreviews-nostar .trustoo-rating-icon {
  width: 20px;
  height: 20px;
}
.collection-icon-list {
  margin: 5px 0;
}
.collection-icon-list .collection-reviews-num {
  margin: 1px 6px 0 3px;
  font-size: 16px;
  line-height: normal;
}
.collection-icon-list .tt-rating-text {
  font-size: 16px;
  line-height: normal;
}
#vstar-reviews #reviews-head {
  display: flex;
}
#vstar-reviews .head-sort {
  width: 40px;
  height: 40px;
  box-sizing: border-box;
}
#vstar-reviews .head-sort .sort-content {
  position: relative;
  width: 100%;
  height: 100%;
}
#vstar-reviews #reviews-body {
  position: relative;
}
#vstar-reviews .list-review .img-item,
#vstar-reviews .list-review .resource-item {
  overflow: hidden;
  width: 100px;
  height: 100px;
}
#vstar-reviews .grid-review {
  position: absolute;
  display: inline-block;
  padding-bottom: 16px;
  border-radius: 8px;
  animation: recover 1s linear;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.12);
  vertical-align: top;
}
#vstar-reviews #reviews-body .reviews-text {
  line-height: 140%;
}
#vstar-reviews #reviews-body svg {
  vertical-align: middle;
}
#vstar-reviews .grid-review .grid-review-head {
  position: relative;
  padding: 0 16px;
  margin-top: 16px;
}
#vstar-reviews .grid-review .user-message {
  margin: 12px 0 12px;
}
#vstar-reviews .grid-review .user-name {
  padding: 0;
  margin-right: 6px;
  font-size: 14px;
  font-weight: 700;
  vertical-align: middle;
}
#vstar-reviews .grid-review .country-name {
  font-size: 16px;
  vertical-align: middle;
}
#vstar-reviews .grid-review .reviews-date {
  font-size: 12px;
  line-height: 22px;
}
#vstar-reviews .grid-review .grid-review-body {
  padding: 0 16px;
}
#vstar-reviews .grid-review .reviews-text {
  font-size: 14px;
  word-wrap: break-word;
}
#vstar-reviews .grid-review .display-text {
  font-size: 14px;
}
#vstar-reviews .grid-review .img-item,
#vstar-reviews .grid-review .resource-item {
  display: block;
  width: 100%;
  border-radius: 8px 8px 0 0;
}
#vstar-reviews .grid-review img {
  width: 100%;
  border-radius: 8px 8px 0 0;
}
.pagefly-star-rating-sealapp:empty,
.ecom-star-rating-sealapp:empty,
.custom-vstar-rating-widget:empty {
  display: block;
}
[class^="trustoo-icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "iconfont" !important;
  font-size: 14px;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  line-height: 1;
  text-transform: none;
}
.trustoo-icon-helpful:before {
  color: var(--font-color);
  content: "\\e605";
}
.trustoo-icon-unhelpful:before {
  color: var(--font-color);
  content: "\\e606";
}
.trustoo-icon-star:before {
  color: var(--star-color);
  content: "\\e602";
}
.trustoo-icon-nostar:before {
  color: var(--nostar-color);
  content: "\\e602";
}
[class^="trustoo-icon-"].rated:before {
  color: var(--star-color);
}
[class^="trustoo-icon-"].no-rated:before {
  color: var(--nostar-color);
}
.trustoo-icon-skirt:before {
  content: "\\e60b";
}
.trustoo-icon-bag:before {
  content: "\\e60f";
}
.trustoo-icon-leaf:before {
  content: "\\e610";
}
.trustoo-icon-tie:before {
  content: "\\e611";
}
.trustoo-icon-cup:before {
  content: "\\e612";
}
.trustoo-icon-fire:before {
  content: "\\e60a";
}
.trustoo-icon-trophy:before {
  content: "\\e613";
}
.trustoo-icon-crown:before {
  content: "\\e614";
}
.trustoo-icon-heart:before {
  content: "\\e615";
}
.trustoo-icon-diamond:before {
  content: "\\e616";
}
.trustoo-icon-shirt:before {
  content: "\\e617";
}
.trustoo-icon-surrounded:before {
  content: "\\e609";
}
.trustoo-icon-spikes:before {
  content: "\\e618";
}
.trustoo-icon-rounded:before {
  content: "\\e608";
}
.trustoo-icon-chef:before {
  content: "\\e60d";
}
.trustoo-icon-footprint:before {
  content: "\\e60e";
}
.trustoo-icon-seedling:before {
  content: "\\e60c";
}
.trustoo-icon-helpful:before {
  content: "\\e605";
}
.trustoo-icon-unhelpful:before {
  content: "\\e606";
}
.trustoo-icon-star:before {
  content: "\\e602";
}
`, "",{"version":3,"sources":["webpack://./static/css/trustoo-insert.less"],"names":[],"mappings":"AACA;EACC,uBAAA;EAAC,uBAAuB;EAExB,gQAAA;AAAD;AAMC;EACC,iBAAA;AAJF;AAOC;EACC,kBAAA;AALF;AAQC;EACC,qBAAA;EACA,sBAAA;AANF;AALA;EAeE,YAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;AAPF;AAUE;EAEE,yBAAA;AATJ;AAYE;EAEE,yBAAA;AAXJ;AAjBA;EAiCG,uBAAA;AAbH;AApBA;EAsCE,kBAAA;AAfF;AAvBA;EA0CE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAhBF;AAjCA;EAoDE,YAAA;AAhBF;AApCA;;EAyDE,eAAA;AAjBF;AAoBA;EACC,WAAA;EACA,YAAA;AAlBD;AAoBA;EACC,iBAAA;AAlBD;AAqBA;;EAGE,WAAA;EACA,YAAA;AApBF;AAwBA;;EAGE,WAAA;EACA,YAAA;AAvBF;AA0BA;;EAGE,WAAA;EACA,YAAA;AAzBF;AA6BA;;EAGE,WAAA;EACA,YAAA;AA5BF;AAgCA;;EAGE,WAAA;EACA,YAAA;AA/BF;AAmCA;EACC,aAAA;AAjCD;AAgCA;EAIE,qBAAA;EACA,eAAA;EACA,mBAAA;AAjCF;AA2BA;EASE,eAAA;EACA,mBAAA;AAjCF;AAqCA;EAEE,aAAA;AApCF;AAkCA;EAME,WAAA;EACA,YAAA;EACA,sBAAA;AArCF;AA6BA;EAWG,kBAAA;EACA,WAAA;EACA,YAAA;AArCH;AA2CA;EACC,kBAAA;AAzCD;AA4CA;;EAEC,gBAAA;EACA,YAAA;EACA,aAAA;AA1CD;AA6CA;EACC,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,4BAAA;EACA,gDAAA;EACA,mBAAA;AA3CD;AA6CA;EACC,iBAAA;AA3CD;AA6CA;EACC,sBAAA;AA3CD;AA6CA;EAEE,kBAAA;EACA,eAAA;EACA,gBAAA;AA5CF;AAwCA;EAQE,mBAAA;AA7CF;AAqCA;EAYE,UAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AA9CF;AA8BA;EAoBE,eAAA;EACA,sBAAA;AA/CF;AA0BA;EAyBE,eAAA;EACA,iBAAA;AAhDF;AAsBA;EA8BE,eAAA;AAjDF;AAmBA;EAkCE,eAAA;EACA,qBAAA;AAlDF;AAeA;EAuCE,eAAA;AAnDF;AAuDA;;EAGE,cAAA;EACA,WAAA;EACA,0BAAA;AAtDF;AAiDA;EASE,WAAA;EACA,0BAAA;AAvDF;AA2DA;;;EAGC,cAAA;AAzDD;AA4DA;EA1DE,+EAA+E;EA4DhF,kCAAA;EACA,eAAA;EA1DC,sCAAsC;EA4DvC,mCAAA;EACA,kCAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;AA1DD;AA6DA;EACC,wBAAA;EACA,gBAAA;AA3DD;AA8DA;EACC,wBAAA;EACA,gBAAA;AA5DD;AA+DA;EACC,wBAAA;EACA,gBAAA;AA7DD;AAgEA;EACC,0BAAA;EACA,gBAAA;AA9DD;AAgEA;EACC,wBAAA;AA9DD;AAgEA;EACC,0BAAA;AA9DD;AAgEA;EACC,gBAAA;AA9DD;AAiEA;EACC,gBAAA;AA/DD;AAkEA;EACC,gBAAA;AAhED;AAmEA;EACC,gBAAA;AAjED;AAoEA;EACC,gBAAA;AAlED;AAqEA;EACC,gBAAA;AAnED;AAsEA;EACC,gBAAA;AApED;AAuEA;EACC,gBAAA;AArED;AAwEA;EACC,gBAAA;AAtED;AAyEA;EACC,gBAAA;AAvED;AA0EA;EACC,gBAAA;AAxED;AA2EA;EACC,gBAAA;AAzED;AA4EA;EACC,gBAAA;AA1ED;AA6EA;EACC,gBAAA;AA3ED;AA8EA;EACC,gBAAA;AA5ED;AA+EA;EACC,gBAAA;AA7ED;AAgFA;EACC,gBAAA;AA9ED;AAiFA;EACC,gBAAA;AA/ED;AAkFA;EACC,gBAAA;AAhFD;AAmFA;EACC,gBAAA;AAjFD","sourcesContent":["// out: false\n@font-face {\n\tfont-family: \"iconfont\";\n\t/* Project id 4017216 */\n\tsrc: url(\"//cdn.vstar.app/static/css/fonts/iconfont.woff2?t=169\") format(\"woff2\"),\n\t\turl(\"//cdn.vstar.app/static/css/fonts/iconfont.woff?t=1681525258204\") format(\"woff\"),\n\t\turl(\"//cdn.vstar.app/static/css/fonts/iconfont.ttf?t=1681525258204\") format(\"truetype\");\n}\n\n.vstar-star {\n\t&.tt-right {\n\t\ttext-align: right;\n\t}\n\n\t&.tt-center {\n\t\ttext-align: center;\n\t}\n\n\t& > * {\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t}\n\n\t.star-item {\n\t\theight: auto;\n\t\tmargin-right: 2px;\n\t\tfont-size: 0;\n\t\tline-height: normal;\n\t}\n\t.star-item {\n\t\t&.nostar {\n\t\t\t.trustoo-rating-icon path {\n\t\t\t\tfill: var(--nostar-color);\n\t\t\t}\n\t\t}\n\t\t&.half-star {\n\t\t\t> .item-nostar .trustoo-rating-icon path {\n\t\t\t\tfill: var(--nostar-color);\n\t\t\t}\n\t\t}\n\n\t\t.trustoo-rating-icon path {\n\t\t\tfill: var(--star-color);\n\t\t}\n\t}\n\n\t.star-item.half-star {\n\t\tposition: relative;\n\t}\n\n\t.item-star {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\toverflow: hidden;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n\t.item-nostar {\n\t\tfont-size: 0;\n\t}\n\n\ti.trustoo-icon-star,\n\ti.trustoo-icon-nostar {\n\t\tdisplay: inline;\n\t}\n}\n#vstar-reviews #reviews-body .trustoo-badge-icon {\n\twidth: 14px;\n\theight: 14px;\n}\n#vstar-reviews .user-verified .trustoo-badge-icon {\n\tmargin-right: 4px;\n}\n\n.product-icon-list.vstar-star {\n\t.star-item,\n\t.trustoo-rating-icon {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t}\n}\n\n.collection-icon-list {\n\t.star-item,\n\t.trustoo-rating-icon {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t}\n}\n#vstar-reviews > #reviews-head {\n\t.star-item,\n\t.trustoo-rating-icon {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t}\n}\n\n.trustoo-widget #reviews-body {\n\t.star-item,\n\t.trustoo-rating-icon {\n\t\twidth: 14px;\n\t\theight: 14px;\n\t}\n}\n\n.noreviews-nostar {\n\t.star-item,\n\t.trustoo-rating-icon {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t}\n}\n\n.collection-icon-list {\n\tmargin: 5px 0;\n\n\t.collection-reviews-num {\n\t\tmargin: 1px 6px 0 3px;\n\t\tfont-size: 16px;\n\t\tline-height: normal;\n\t}\n\t.tt-rating-text {\n\t\tfont-size: 16px;\n\t\tline-height: normal;\n\t}\n}\n\n#vstar-reviews {\n\t#reviews-head {\n\t\tdisplay: flex;\n\t}\n\n\t.head-sort {\n\t\twidth: 40px;\n\t\theight: 40px;\n\t\tbox-sizing: border-box;\n\n\t\t.sort-content {\n\t\t\tposition: relative;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t}\n\t}\n}\n\n// Mark 瀑布流样式\n#vstar-reviews #reviews-body {\n\tposition: relative;\n}\n\n#vstar-reviews .list-review .img-item,\n#vstar-reviews .list-review .resource-item {\n\toverflow: hidden;\n\twidth: 100px;\n\theight: 100px;\n}\n\n#vstar-reviews .grid-review {\n\tposition: absolute;\n\tdisplay: inline-block;\n\tpadding-bottom: 16px;\n\tborder-radius: 8px;\n\tanimation: recover 1s linear;\n\tbox-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.12);\n\tvertical-align: top;\n}\n#vstar-reviews #reviews-body .reviews-text {\n\tline-height: 140%;\n}\n#vstar-reviews #reviews-body svg {\n\tvertical-align: middle;\n}\n#vstar-reviews .grid-review {\n\t.grid-review-head {\n\t\tposition: relative;\n\t\tpadding: 0 16px;\n\t\tmargin-top: 16px;\n\t}\n\n\t.user-message {\n\t\tmargin: 12px 0 12px;\n\t}\n\n\t.user-name {\n\t\tpadding: 0;\n\t\tmargin-right: 6px;\n\t\tfont-size: 14px;\n\t\tfont-weight: 700;\n\t\tvertical-align: middle;\n\t}\n\n\t.country-name {\n\t\tfont-size: 16px;\n\t\tvertical-align: middle;\n\t}\n\n\t.reviews-date {\n\t\tfont-size: 12px;\n\t\tline-height: 22px;\n\t}\n\n\t.grid-review-body {\n\t\tpadding: 0 16px;\n\t}\n\n\t.reviews-text {\n\t\tfont-size: 14px;\n\t\tword-wrap: break-word;\n\t}\n\n\t.display-text {\n\t\tfont-size: 14px;\n\t}\n}\n\n#vstar-reviews .grid-review {\n\t.img-item,\n\t.resource-item {\n\t\tdisplay: block;\n\t\twidth: 100%;\n\t\tborder-radius: 8px 8px 0 0;\n\t}\n\n\timg {\n\t\twidth: 100%;\n\t\tborder-radius: 8px 8px 0 0;\n\t}\n}\n\n.pagefly-star-rating-sealapp:empty,\n.ecom-star-rating-sealapp:empty,\n.custom-vstar-rating-widget:empty {\n\tdisplay: block;\n}\n\n[class^=\"trustoo-icon-\"] {\n\t/* use !important to prevent issues with browser extensions that change fonts */\n\tfont-family: \"iconfont\" !important;\n\tfont-size: 14px;\n\t/* Better Font Rendering =========== */\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\tfont-style: normal;\n\tfont-variant: normal;\n\tfont-weight: normal;\n\tline-height: 1;\n\ttext-transform: none;\n}\n\n.trustoo-icon-helpful:before {\n\tcolor: var(--font-color);\n\tcontent: \"\\e605\";\n}\n\n.trustoo-icon-unhelpful:before {\n\tcolor: var(--font-color);\n\tcontent: \"\\e606\";\n}\n\n.trustoo-icon-star:before {\n\tcolor: var(--star-color);\n\tcontent: \"\\e602\";\n}\n\n.trustoo-icon-nostar:before {\n\tcolor: var(--nostar-color);\n\tcontent: \"\\e602\";\n}\n[class^=\"trustoo-icon-\"].rated:before {\n\tcolor: var(--star-color);\n}\n[class^=\"trustoo-icon-\"].no-rated:before {\n\tcolor: var(--nostar-color);\n}\n.trustoo-icon-skirt:before {\n\tcontent: \"\\e60b\";\n}\n\n.trustoo-icon-bag:before {\n\tcontent: \"\\e60f\";\n}\n\n.trustoo-icon-leaf:before {\n\tcontent: \"\\e610\";\n}\n\n.trustoo-icon-tie:before {\n\tcontent: \"\\e611\";\n}\n\n.trustoo-icon-cup:before {\n\tcontent: \"\\e612\";\n}\n\n.trustoo-icon-fire:before {\n\tcontent: \"\\e60a\";\n}\n\n.trustoo-icon-trophy:before {\n\tcontent: \"\\e613\";\n}\n\n.trustoo-icon-crown:before {\n\tcontent: \"\\e614\";\n}\n\n.trustoo-icon-heart:before {\n\tcontent: \"\\e615\";\n}\n\n.trustoo-icon-diamond:before {\n\tcontent: \"\\e616\";\n}\n\n.trustoo-icon-shirt:before {\n\tcontent: \"\\e617\";\n}\n\n.trustoo-icon-surrounded:before {\n\tcontent: \"\\e609\";\n}\n\n.trustoo-icon-spikes:before {\n\tcontent: \"\\e618\";\n}\n\n.trustoo-icon-rounded:before {\n\tcontent: \"\\e608\";\n}\n\n.trustoo-icon-chef:before {\n\tcontent: \"\\e60d\";\n}\n\n.trustoo-icon-footprint:before {\n\tcontent: \"\\e60e\";\n}\n\n.trustoo-icon-seedling:before {\n\tcontent: \"\\e60c\";\n}\n\n.trustoo-icon-helpful:before {\n\tcontent: \"\\e605\";\n}\n\n.trustoo-icon-unhelpful:before {\n\tcontent: \"\\e606\";\n}\n\n.trustoo-icon-star:before {\n\tcontent: \"\\e602\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
